import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AuthModule } from '../auth/auth.module';
import { BloodGroupEntity } from '../bloodgroup/blood-group.entity';
import { UserEntity } from '../user/user.entity';
import { UserModule } from '../user/user.module';
import { WelfareModule } from '../welfare/welfare.module';
import { ProfileController } from './profile.controller';
import { ProfileEntity } from './profile.entity';
import { ProfileService } from './profile.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ProfileEntity,UserEntity,BloodGroupEntity]), 
    forwardRef(()=>WelfareModule),
  ],
  providers: [ProfileService],
  controllers: [ProfileController],
  exports: [ProfileService]
})
export class ProfileModule {}


